import updateTableCurrentLoadedIndex, { type UPDATE_TABLE_CURRENT_LOADED_INDEXActionMessage, } from "owa-mail-triage-table-utils/lib/actions/updateTableCurrentLoadedIndex";
import { getStore } from "owa-mail-list-store";
import { mutator } from "satcheljs";

const defaultExport: (actionMessage: UPDATE_TABLE_CURRENT_LOADED_INDEXActionMessage) => void = mutator(updateTableCurrentLoadedIndex, actionMessage => {
    const tableView = getStore().tableViews.get(actionMessage.tableViewId);
    if (tableView) {
        tableView.currentLoadedIndex = actionMessage.currentLoadedIndexToSet;
    }
});
export default defaultExport;
